// extracted by mini-css-extract-plugin
export default {"container":"jOBiKk","title":"fBnvrf","subtitle":"UBZeLf"};